// @flow

import styled from 'styled-components';
import type { Theme } from '../../../../../types';
import type { ReviewTemplate } from '../../../types';

type Props = {
  template: ReviewTemplate,
};

export default styled<any, Theme, Props>('span')`
  color: ${props => props.theme.review[props.template].reviewCountColor};
  display: inline-block;
  margin-right: .5rem;
  white-space: nowrap;
`;
